import { noop } from 'lodash-es';
import {
  AnchorHTMLAttributes,
  ComponentProps,
  DetailedHTMLProps,
  createContext,
  useContext
} from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const MenuContext = createContext(noop);

type AnchorProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

type NavProps = ComponentProps<typeof NavLink>;

function isAnchorProps(props: AnchorProps | NavProps): props is AnchorProps {
  return 'href' in props;
}

function MenuLink(props: AnchorProps | NavProps) {
  const hideMenu = useContext(MenuContext);
  if (isAnchorProps(props)) {
    const { children } = props;
    return (
      <a
        {...props}
        onClick={hideMenu}
        role="none"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }
  return <NavLink {...props} activeClassName="active" onClick={hideMenu} />;
}

export const MenuItem = styled(MenuLink)`
  display: block;
  align-self: flex-start;
  font-size: 1.5rem;
  line-height: 1.5;
  padding: 5px 0;
  position: relative;
  &,
  &:hover {
    text-decoration: none;
    color: rgba(255, 255, 255, 1);
  }
  &:not(.active) {
    color: rgba(255, 255, 255, 0.5);
  }
`;
